<div class="stickyMenu">
    <nav class="stickyMenu-nav">
        {{#if horizontalFlow}}
            {{#ifGreaterThan currentItem 0}}
                <div class="stickyMenu-nav-arrowLeft js--action-stickyMenu-nav-arrowLeft"></div>
            {{/ifGreaterThan}}
        {{/if}}
        <ul class="stickyMenu-nav-list"{{#if horizontalFlow}} style="margin-left: -{{currentItemOffset}}px;"{{/if}}>
            {{#each menuItems}}
                <li class="stickyMenu-nav-list">
                    <a{{#unless @root.windowTop}}{{#ifEquals @root.currentItem itemIndex}} class="isActive"{{/ifEquals}}{{/unless}} href="#{{href}}">{{name}}</a>
                </li>
            {{/each}}
        </ul>
        {{#if horizontalFlow}}
            {{#ifLessThan currentItem totalItems}}
                <div class="stickyMenu-nav-arrowRight js--action-stickyMenu-nav-arrowRight"></div>
            {{/ifLessThan}}
        {{/if}}
    </nav>
</div>